/**
 * Волна A (docs/MIGRATION_ROUTER.md §5). Было: <DevRoute exact path='/dev/modals'>.
 * DevRoute — без шапки/подвала (staticData); <main> теперь даёт LayoutShell (волна E).
 */
import { createFileRoute } from '@tanstack/react-router';
import DevModalsPage from '@routes/DevModals';

export const Route = createFileRoute('/dev/modals')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => <DevModalsPage />
});
